module.exports = __webpack_public_path__ + "media/images/about-background-703962cc62a2aabf4492f251a8b2db77.jpg";